import { type sfCollection } from "@unlikelystudio/commerce-connector"

import { SHOPIFY_FILTERS_SORT_BY, type SHOPIFY_FILTERS_SORT_KEYS } from "~/lib/shopify/constants/collection-filters"

export function getSfSortFromSortByParam(
  sortBy: SHOPIFY_FILTERS_SORT_KEYS
): Pick<Parameters<typeof sfCollection>[1], "productsSortKey" | "productReverse"> {
  const fallBack = SHOPIFY_FILTERS_SORT_BY["default"]
  return SHOPIFY_FILTERS_SORT_BY[sortBy] ?? fallBack
}
